import React, { Component } from "react";
import { ModuleAccordionGroup } from "@loanbossinc/component-library";
import { AccordionSection } from "component-lib/AccordionSection";

import { LOAN_SECTION_KEYS } from "../loan.constants";

import { rows } from "./section-loan-closing-costs-rows";

const nullData = {
  stylename: "Work Sans /  16 Regular",
  fontFamily: "Work Sans",
  fontSize: "16px",
  fontStyle: "normal",
  fontWeight: 400,
  lineHeight: "19px",
  letterSpacing: "0em",
  textAlign: "center",
  textColor: "#7d8084"
};

/*
 * NOTE: This section needs loanTypeId to decide if it is going to show something
 *       so the path is not just to closingCosts
 */

export class LoanClosingCosts extends Component {
  drawDataClosingCosts(data) {
    if (data.closingCosts) {
      if (data.closingCosts.originationFeeAmount ||
        data.closingCosts.modificationFeeAmount ||
        data.closingCosts.brokerFeeAmount ||
        data.closingCosts.lenderLegalFeeAmount ||
        data.closingCosts.borrowerLegalFeeAmount ||
        data.closingCosts.inspectionFeeAmount ||
        data.closingCosts.rateLockFeeAmount ||
        data.closingCosts.hedgeFeeAmount ||
        data.closingCosts.titleAmount ||
        data.closingCosts.otherAmount) {
        return <AccordionSection eventHandlers={this.props.eventHandlers} rows={rows} data={data} />;
      }

      return (<p style={nullData}>Data has not been entered for this section.</p>);
    }

    return (<p style={nullData}>Data has not been entered for this section.</p>);
  }

  render() {
    const { data, history, loanId, enableEditButton, eventHandlers, ...other } = this.props;

    if (!data) {
      return null;
    }

    return (
      <ModuleAccordionGroup
        {...other}
        groups={[
          {
            title: "Closing Costs",
            key: LOAN_SECTION_KEYS.CLOSING_COSTS,
            isTitleGroup: true,
            isExpandable: true,
            buttonLabel: "Edit Details",
            showEditButton: enableEditButton,
            onClick: () => history.push(`/loans/${loanId}/edit/${LOAN_SECTION_KEYS.CLOSING_COSTS}`),
            sections: [
              this.drawDataClosingCosts(data)
            ],
            references: data.references,
            eventHandlers,
            referencedFieldPath: "loans.closingcosts.header",
            referenceStyles: { marginLeft: "20px" }
          }
        ]}
      />
    );
  }
}
